export default __webpack_public_path__ + "static/qrcover-79429ec1071be121bc595dc9d9c28bdc.jpg";